import { defineStore } from "pinia";
import { useContractStore } from "./contract";

import paymentScheduleJs from "../models/paymentSchedule";

import paynet from "@/network/payment";
import { useContractInfoStore } from '@/store/contractinfo'
import dateJs from "@/assets/js/date";
import numberjs from "../assets/js/numberjs";

export const usePaymentStore = defineStore("payment", {
  state: () => {
    return {
      // 付款摘要信息
      PaymentSummary: {
        id: 0,
      },
      // 付款时间表
      PaymentSchedules: [],
      // 付款时间明细
      PaymentScheduleDetails: [],
      // 当前处理的付款时间
      PaymentScheduleSetting: {},
      // 当前处理的付款时间明细
      PaymentDetails: [],
      ContractActions: []
    }
  },
  actions: {
    /**
     * 刷新Payment
     */
    async RefreshPayment () {
      const useContract = useContractStore();
      const ContractId = useContract.Id

      const res = await paynet
        .getPaymentScheduleSummary(0, ContractId)
        .then((res) => res.data);

      // 付款摘要信息
      this.PaymentSummary = res.psSummary;

      // 付款明细选项
      this.ContractActions = res.contractActions

      // 付款时间表
      this.PaymentSchedules = res.payments.map(t => paymentScheduleJs.PaymentScheduleEntity(t));
      this.PaymentScheduleDetails = res.paymentScheduleDetails;
    },
    /**
     * 当前付款时间预设
     * @param {*} PaymentId 付款时间表Id
     */
    async getPaymentScheduleSetting (paymentUniqueId, ContractAction) {
      var PaymentScheduleEntity = this.PaymentSchedules.find(t => t.uniqueId === paymentUniqueId) || null
      if (PaymentScheduleEntity === null) {
        PaymentScheduleEntity = this.presetPaymentSchedule(ContractAction)
      }

      this.PaymentScheduleSetting = paymentScheduleJs.PaymentScheduleSettingEntity(PaymentScheduleEntity)

      this.PaymentDetails = this.PaymentScheduleDetails.filter(
        (t) => t.paymentUniqueId == paymentUniqueId
      ) || [];

    },
    /**
     * 预设Payment Schedule
     * @param {String} ContractAction Media/Prdoctuion选项
     * @returns 
     */
    presetPaymentSchedule (ContractAction) {
      const useContract = useContractStore()
      const useContractInfo = useContractInfoStore()

      // 计算计划付款日期
      const CampaignPeriodStart = this.PaymentSummary.campaignPeriodStart;
      const CampaignPeriodEnd = this.PaymentSummary.campaignPeriodEnd

      var ScheduleMediaAmount = 0;
      var ScheduleProductionAmount = 0;
      var ContractDraftNo = ""
      ContractDraftNo = useContractInfo.Contract.contractDraftNoProduction

      if (ContractAction != "production") {
        ScheduleMediaAmount = this.PaymentSummary.totalOutstandingMediaAmount;
        if (ContractAction === "media+production" || ContractAction === "media") {
          ContractDraftNo = useContractInfo.Contract.contractDraftNoMedia
        }
      }

      if (ContractAction != "media") {
        ScheduleProductionAmount = this.PaymentSummary.totalOutstandingProductionAmount;
        if (ContractAction !== "media+production") {
          ContractDraftNo = useContractInfo.Contract.contractDraftNoProduction
        }
      }

      var PaymentTerm = ""
      var InvoiceTerm = ""
      if ((useContract.ContractSummary.businessNature || "") !== "") {
        if (useContract.ContractSummary.businessNature != "Government") {
          if (dateJs.DateDiff(new Date(), CampaignPeriodStart) + 1 <= 30) {
            PaymentTerm = InvoiceTerm = "cod";
          }
          else {
            PaymentTerm = "csdm30";
            InvoiceTerm = "duem14";
          }
        }
        else {
          PaymentTerm = "ceda30";
          InvoiceTerm = "ced";
        }
      }




      const preset = {
        id: 0,
        paymentSummaryId: this.PaymentSummary.id,
        contractType: useContractInfo.Contract.contractType,
        contractAction: ContractAction,
        contractId: useContractInfo.Contract.id,
        campaignPeriodStart: CampaignPeriodStart,
        campaignPeriodEnd: CampaignPeriodEnd,
        noOfDays: dateJs.DateDiff(CampaignPeriodStart, CampaignPeriodEnd) + 1,
        scheduleMediaAmount: ScheduleMediaAmount,
        scheduleProductionAmount: ScheduleProductionAmount,
        totalScheduleAmount: ScheduleMediaAmount + ScheduleProductionAmount,
        psType: "fullpayment",
        paymentTerm: PaymentTerm,
        invoiceTerm: InvoiceTerm,
        currency: "HKD",
        contractDraftNo: [ContractDraftNo]
      }

      return preset
    },
    /**
     * 更新付款时间
     */
    updatePaymentSchedule () {
      var oPaymentSchedule = this.PaymentSchedules.find(t => t.uniqueId === this.PaymentScheduleSetting.uniqueId) || null
      if (oPaymentSchedule === null) {

        this.PaymentSchedules.push({
          uniqueId: this.PaymentScheduleSetting.uniqueId
        })

        oPaymentSchedule = this.PaymentSchedules.find(t => t.uniqueId === this.PaymentScheduleSetting.uniqueId)
      }

      const index = this.PaymentSchedules.indexOf(oPaymentSchedule)

      // 付款时间
      const reqeustPs = paymentScheduleJs.PaymentScheduleEntity(this.PaymentScheduleSetting);
      this.PaymentSchedules[index] = reqeustPs

      // 付款时间明细
      var PaymentScheduleDetail = this.PaymentScheduleDetails.find(t => t.paymentUniqueId === oPaymentSchedule.uniqueId) || null
      if (PaymentScheduleDetail === null) {
        this.PaymentScheduleDetails.push({
          paymentUniqueId: oPaymentSchedule.uniqueId
        })
        PaymentScheduleDetail = this.PaymentScheduleDetails.find(t => t.paymentUniqueId === oPaymentSchedule.uniqueId)
      }

      const detailIndex = this.PaymentScheduleDetails.indexOf(PaymentScheduleDetail)
      this.PaymentScheduleDetails[detailIndex] = this.PaymentDetails[0]

      // 更新Total Outstanding
      this.totalOutStanding()
    },
    /**
     * 保存数据
     */
    async SaveData () {
      // 付款摘要
      const RequestPaymentSummary = paymentScheduleJs.SavePaymentSummaryParam(this.PaymentSummary)

      // 付款时间表
      const RequestPayments = this.PaymentSchedules.map(t => paymentScheduleJs.SavePaymentParam(t))

      const RequestPaymentDetails = this.PaymentScheduleDetails

      const RequestParam = {
        RequestPaymentSummary,
        RequestPayments,
        RequestPaymentDetails
      }
      const message = await paynet.savePaymentSchedule(RequestParam).then(res => res.data) || ""

      if (message === "") {
        this.RefreshPayment()
      }

      return message;

    },
    /**
     * 删除付款时间
     * @param {*} paymentId GUID标识
     */
    deletePayment (PaymentUniqueId) {
      const Payment = this.PaymentSchedules.find(t => t.uniqueId === PaymentUniqueId)
      const PaymentIndex = this.PaymentSchedules.indexOf(Payment)

      // 删除付款时间
      this.PaymentSchedules.splice(PaymentIndex, 1)

      // 删除付款时间明细
      const PaymentDetails = this.PaymentScheduleDetails.filter(t => t.paymentUniqueId === PaymentUniqueId) || []

      PaymentDetails.forEach((entity) => {
        const index = this.PaymentScheduleDetails.indexOf(entity)
        this.PaymentScheduleDetails.splice(index, 1)

      })

      this.totalOutStanding()

    },
    /**
     * 更新Total Outstanding
     */
    totalOutStanding () {

      const mediaScheduleAmount = this.PaymentScheduleDetails.length === 0 ? 0 : numberjs.Sum(this.PaymentScheduleDetails.map(t => parseFloat(t.mediaInstallmentAmount || 0)))
      const prodcutionScheduleAmount = this.PaymentScheduleDetails.length === 0 ? 0 : numberjs.Sum(this.PaymentScheduleDetails.map(t => parseFloat(t.productionInstallmentAmount || 0)))

      console.log("1", mediaScheduleAmount, prodcutionScheduleAmount);

      this.PaymentSummary.totalOutstandingMediaAmount = numberjs.Subtraction(this.PaymentSummary.totalMediaAmount, mediaScheduleAmount)
      this.PaymentSummary.totalOutstandingProductionAmount = numberjs.Subtraction(this.PaymentSummary.totalProductionAmount, prodcutionScheduleAmount)
    }
  }
})
